<template>
  <card-container
    :id="pageId"
    :class="pageId"
    :is-loading="isLoading"
    :disabled="isLoading"
    loading-message="Rescaning the Ride for Changes..."
    @submit="submitForm"
    @reset="resetForm"
  >
    <template #title>
      Rescan Ride for Changes
    </template>

    <template #content>
      <div class="row align-items-center">
        <label class="col-sm-3 control-label">Request Id*</label>
        <div class="col-sm-7">
          <sanitized-input
            :id="`requestId-${pageId}`"
            v-model="requestId"
            placeholder="Request ID"
            required
          />
        </div>
      </div>

      <fieldset
        v-if="rideInfo.length > 0"
        class="ride-info"
      >
        <hr>
        <div
          v-for="(item, index) in rideInfo"
          :key="index"
          class="row"
          :class="{'image-container text-center ml-10': item.type === 'image'}"
        >
          <label class="col-sm-3 control-label">{{ item.label }}:&nbsp;</label>
          <div
            v-if="item.type !== 'image'"
            v-dompurify-html="item.value ?? ''"
            class="col-sm-8 info-item"
          />
          <img
            v-else
            :src="item.value"
            class="info-item"
          >
        </div>
      </fieldset>
    </template>

    <template #submit-button>
      Rescan
    </template>
  </card-container>
</template>

<script lang="ts">
import { ref, Ref, watch } from 'vue';

import util from '@/Utils/util';
import rideUtility from '@/Utils/rideUtility';
import { useCustomer } from '@/use/customer';
import { useSwalDialog } from '@/use/swalDialog';
import { RideInfoItem } from '@/models/ride';
import { rideService } from '@/services/ride';

const pageId = 'rescan-ride';

export default {
  name: 'RescanRide',

  setup: () => {
    const { lastRideInfo } = useCustomer();
    const { showErrorPopupDialog } = useSwalDialog();

    const requestId = ref('');
    const rideInfo: Ref<RideInfoItem[]> = ref([]);
    const isLoading = ref(false);

    const submitForm = async () => {
      rideInfo.value = [];

      isLoading.value = true;
      try {
        const response = await rideService.repollAndMarkRide(requestId.value);

        // make the ride info with response
        rideInfo.value = rideUtility.constructRideTxtArray(response);
      } catch (error) {
        const errorText = util.getGraphqlError(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
      }
      isLoading.value = false;
    };

    const resetForm = () => {
      requestId.value = '';
      rideInfo.value = [];
    };

    watch(
      lastRideInfo,
      (value: any) => {
        resetForm();
        requestId.value = value?.requestId;
      },
      {
        immediate: true,
      },
    );

    return {
      pageId,
      requestId,
      rideInfo,
      isLoading,

      submitForm,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
.rescan-ride {
  .image-container {
    img {
      width: 50%;
    }
  }

  .info-item {
    text-align: left;
  }
}
</style>
